<template>	
	  <van-search v-model="value" 
      placeholder="请输入搜索关键词,例如M280DW..." 
      class="van-search"
	   shape="round"
	    background="#E0E0E0"
      @search="onSearch"
      />
</template>

<script>
	import global  from './global.vue';
	export default {
	  name: 'search',	 
	  data(){
	  		return{			
	  		    value :''
	  		}  	 
		},
		methods:{
			onSearch(){
				if ( this.value.length > 0 )
				{
                global.applog('搜索产品内容')
				this.$router.push({ path:'/productinfo?sn=' + this.$route.query.sn + '&model=' + this.value + '&icon=' })
				}
            }
		}
	  }
</script>
<style>
 .van-search {
      border: none !important; /* 去掉实线边框 */
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.1); /* 添加虚化效果，您可以根据需要调整阴影参数 */
      background-color: #F0F0F0;
    }   
</style>